"use strict";

exports.__esModule = true;
exports.OperatorDeviceSelector = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Theme = require("../../Theme");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var DeviceSelectorView = _styledComponents["default"].div.withConfig({
  displayName: "OperatorDeviceSelectorlegacy__DeviceSelectorView",
  componentId: "sc-17cjwxe-0"
})(["margin-top:1rem;margin-bottom:1rem;margin-right:1rem;display:grid;grid-template-columns:repeat(auto-fill,minmax(200px,1fr));grid-auto-rows:max-content;grid-column-gap:1rem;grid-row-gap:1rem;overflow:auto;"]);
var DeviceSelectorButton = _styledComponents["default"].button.withConfig({
  displayName: "OperatorDeviceSelectorlegacy__DeviceSelectorButton",
  componentId: "sc-17cjwxe-1"
})(["all:unset;cursor:pointer;box-sizing:border-box;flex:1;font-size:1.3rem;font-weight:bold;text-align:center;overflow-wrap:break-word;padding:", ";color:", ";background:", ";border:", ";"], (0, _Theme.val)("ButtonPaddingLarge"), (0, _Theme.selectable)("DeviceSelectorButtonColor"), (0, _Theme.selectable)("DeviceSelectorButtonBackground"), (0, _Theme.selectable)("DeviceSelectorButtonBorder"));

/**
 * Allows an operator to select a device from a list.
 */
var OperatorDeviceSelector = exports.OperatorDeviceSelector = /*#__PURE__*/function (_Component) {
  function OperatorDeviceSelector() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(OperatorDeviceSelector, _Component);
  var _proto = OperatorDeviceSelector.prototype;
  _proto.createClickHandler = function createClickHandler(device) {
    var _this = this;
    return function () {
      var _this$props = _this.props,
        onSelect = _this$props.onSelect,
        multiple = _this$props.multiple,
        selected = _this$props.selected;
      var updated = [];
      if (multiple) {
        var found = false;
        for (var i = 0; i < selected.length; i++) {
          var item = selected[i];
          if (item.uuid === device.uuid) {
            found = true;
          } else {
            updated.push(item);
          }
        }
        if (!found) {
          updated.push(device);
        }
      } else if (selected.length === 0 || selected[0].uuid !== device.uuid) {
        updated.push(device);
      }
      onSelect(updated);
    };
  };
  _proto.isDeviceSelected = function isDeviceSelected(device) {
    var selected = this.props.selected;
    for (var i = 0; i < selected.length; i++) {
      if (selected[i].uuid === device.uuid) {
        return true;
      }
    }
    return false;
  };
  _proto.render = function render() {
    var _this2 = this;
    var devices = this.props.devices;
    return /*#__PURE__*/_react["default"].createElement(DeviceSelectorView, null, devices.map(function (device) {
      return /*#__PURE__*/_react["default"].createElement(DeviceSelectorButton, {
        key: device.uuid,
        "aria-selected": _this2.isDeviceSelected(device),
        onClick: _this2.createClickHandler(device)
      }, device.name);
    }));
  };
  return OperatorDeviceSelector;
}(_react.Component);
OperatorDeviceSelector.defaultProps = {
  selected: [],
  multiple: false
};